import assertNever from 'assert-never';
import React from 'react';

import { PublishStatus, QuestionStatus } from '../../../graphql/gen/types';
import { DomainVisibilityIcon, PrivateVisibilityIcon, TeamVisibilityIcon } from '../shared/VisibilityIcons';

type Props = {
  plexPublishStatus: PublishStatus | QuestionStatus;
  plexName: string;
};

export function PostVisibility(props: Props): React.ReactElement {
  const { plexPublishStatus, plexName } = props;

  switch (plexPublishStatus) {
    case PublishStatus.Draft:
    case QuestionStatus.Draft:
    case QuestionStatus.Ignored: // TODO what do we show for this case?
      return <PrivateVisibilityIcon />;

    case PublishStatus.Internal:
    case QuestionStatus.Internal:
      return <TeamVisibilityIcon plexName={plexName} />;

    case PublishStatus.Published:
    case QuestionStatus.Published:
      return <DomainVisibilityIcon />;
  }

  return assertNever(plexPublishStatus);
}
